import * as React from "react";
import { USPList } from "@grandvisionhq/common";
import { LocationSearch } from "@grandvisionhq/locations";
import { useIntl } from "@grandvisionhq/state";
import { useStoreFinderContext, Hooks, Components } from "@grandvisionhq/stores-v2";
import { fromStoreResultToStore } from "../../../../../pages/BookAppointment/adapters/v3/pages/BookAppointment/adapters/from-store-result-to-store.js";
import AppointmentInfoContainer from "../../../../LinkedAppointmentInfo/v3/components/LinkedAppointmentInfo/LinkedAppointmentInfoContainer.js";
import SelectedChoicesContainer from "../../../../SelectedChoices/v3/components/SelectedChoices/SelectedChoicesContainer.js";
import HighlightPreferredStore from "../../../HighlightPreferredStore/v3/components/StoreFinder/HighlightPreferredStore/HighlightPreferredStoreContainer.js";
import NoStoresAlertContainer from "../../../NoStoresAlert/v3/components/StoreFinder/NoStoresAlert/NoStoresAlertContainer.js";
import StoreFinderItemContainer from "../../../StoreFinderItem/v3/components/StoreFinder/StoreFinderItem/StoreFinderItemContainer.js";
import StoreFinderMapContainer from "../../../StoreFinderMap/v3/components/StoreFinder/StoreFinderMap/StoreFinderMapContainer.js";
import StoreFinderSearchFormContainer from "../../../StoreFinderSearchForm/v3/components/StoreFinder/StoreFinderSearchForm/StoreFinderSearchFormContainer.js";
/* empty css                          */
import useVirtualAppointment from "../../../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
const StoreListTopContent = Components.StoreListTopContent;
const StoreFinderContainer = ({ appointmentTypeId }) => {
  const { getLabel, hasLabel } = useIntl();
  const { isPristineSearch, isStoresLoading, stores, config } = useStoreFinderContext();
  const { googleMapsId } = config;
  const showTabs = Hooks.useTabs();
  const [{}, { enabled: isVirtualAppointmentEnabled }] = useVirtualAppointment();
  const storeListTopContent = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "appointments-store-finder__selected-choices" }, /* @__PURE__ */ React.createElement(SelectedChoicesContainer, null)), /* @__PURE__ */ React.createElement(AppointmentInfoContainer, { className: "appointments-store-finder__linked-appointment-type" }), /* @__PURE__ */ React.createElement(
    StoreListTopContent,
    {
      title: getLabel("appointments.component.storeFinder.title"),
      description: hasLabel("appointments.component.storeFinder.description") ? getLabel("appointments.component.storeFinder.description") : void 0
    }
  ));
  const uspList = /* @__PURE__ */ React.createElement("div", { className: "appointments-store-finder__usp-list" }, /* @__PURE__ */ React.createElement(
    USPList,
    {
      usps: [
        "appointments.component.storeFinder.usp1",
        "appointments.component.storeFinder.usp2",
        "appointments.component.storeFinder.usp3"
      ]
    }
  ));
  const showNoStoresAlert = !isPristineSearch && !isStoresLoading && stores.length === 0;
  const showUSPs = !isVirtualAppointmentEnabled && !isStoresLoading && stores.length === 0;
  const storeListInfoContent = /* @__PURE__ */ React.createElement(React.Fragment, null, showNoStoresAlert ? /* @__PURE__ */ React.createElement("div", { className: "appointments-store-finder__info-content" }, /* @__PURE__ */ React.createElement(NoStoresAlertContainer, null)) : null, showUSPs ? uspList : null);
  return /* @__PURE__ */ React.createElement(
    LocationSearch,
    {
      className: "appointments-store-finder",
      googleMapsId,
      showTabs,
      searchForm: /* @__PURE__ */ React.createElement(StoreFinderSearchFormContainer, { appointmentTypeId }),
      listTopContent: storeListTopContent,
      listInfoContent: storeListInfoContent,
      loadingListItems: isStoresLoading,
      listItems: stores.length ? stores.map((store) => /* @__PURE__ */ React.createElement(
        StoreFinderItemContainer,
        {
          key: store.globalStoreId,
          variant: "list-item",
          store: fromStoreResultToStore(store),
          "data-t": "searchResults"
        }
      )) : [],
      mapContent: /* @__PURE__ */ React.createElement(StoreFinderMapContainer, { stores, googleMapsId }),
      highlightPreferredStore: /* @__PURE__ */ React.createElement(HighlightPreferredStore, { applicableAppointmentTypeId: appointmentTypeId })
    }
  );
};
export {
  StoreFinderContainer as default
};
//# sourceMappingURL=StoreFinderContainer.js.map
